import shipperActions from "@/models/shipperActions";
import useNotificationStore from "@/stores/notifications";
import { useShipperStore } from "@/stores/shipper";
import { RouteRecordRaw } from "vue-router";

const ShipperWrapper = () => import("@/pages/pricing/shipper/ShipperWrapper.vue");
const ShipperReview = () => import("@/pages/pricing/shipper/ShipperReview.vue");
const ShipperConfirmation = () => import("@/pages/pricing/shipper/ShipperConfirmationPage.vue");

const routes: RouteRecordRaw = {
  name: "shipperPage",
  path: "/shipper",
  component: ShipperWrapper,
  children: [
    {
      name: "shipperReview",
      path: ":customerId/quote/:quoteId",
      component: ShipperReview,
      meta: {
        title: `Review Quote`,
      },
      beforeEnter: async (to) => {
        const shipperStore = useShipperStore();
        const notifier = useNotificationStore();
        shipperStore.customerId = to.params.customerId as string;
        shipperStore.quoteId = to.params.quoteId as string;
        shipperStore.token = to.query.token as string;
        await shipperStore.getQuote().catch((error) => {
          return console.error("Unable to load quote: ", error);
        });
        if (!shipperStore.receivedQuote) {
          notifier.setToast("danger", "Unable to load quote. Please submit a new request or contact your partner.", 0);
          return undefined;
        }

        // Handle deleted first
        if (shipperStore.receivedQuote?.deleted) {
          return {
            name: "shipperConfirmation",
            params: {
              customerId: to.params.customerId as string,
              quoteId: to.params.quoteId as string,
            },
            query: {
              action: shipperActions.DELETED,
            },
          };
        }

        switch (shipperStore.receivedQuote?.statusCode) {
          case 50:
            return {
              name: "shipperConfirmation",
              params: {
                customerId: to.params.customerId as string,
                quoteId: to.params.quoteId as string,
              },
              query: {
                action: shipperActions.ACCEPT,
              },
            };
          case 3:
            return {
              name: "shipperConfirmation",
              params: {
                customerId: to.params.customerId as string,
              },
              query: {
                action: shipperActions.REJECT,
              },
            };
          case 4:
            return {
              name: "shipperConfirmation",
              params: {
                customerId: to.params.customerId as string,
                quoteId: to.params.quoteId as string,
              },
              query: {
                action: shipperActions.DELETED,
              },
            };
          default:
            return;
        }
      },
    },
    {
      name: "shipperConfirmation",
      path: ":customerId/confirmation/:quoteId",
      component: ShipperConfirmation,
      meta: {
        title: `Quote Confirmation`,
      },
    },
  ],
};

export default routes;
